import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { reduxForm, formValueSelector, SubmissionError, clearSubmitErrors } from 'redux-form'
import ReportForm, {
    contentType,
    executionTypes,
    reports,
    weekdays,
    reportTypes,
    relativeTypes
} from "../components/report/ReportForm";
import {updateReportConfig, fetchReportConfig} from "../store/actions/report";
import translate from "../lib/i18n/translate";

const formSelector = formValueSelector('reportForm');

const mapStateToProps = (state) => {
    const {reportConfig, loading, loaded, error, saving, saved} = state.report;

    let initialValues = {};

    if (reportConfig) {
        initialValues = {
            ...reportConfig,
            content: reportConfig.contentSinceLastExecution ? contentType.ALL : contentType.RELATIVE,
            executionType: reportConfig.executionDay ? executionTypes.DAY_IN_MONTH : executionTypes.WEEKDAY,
            weekday: weekdays.map(weekday => ({
                name: weekday,
                checked: reportConfig.executionWeekDays && !!reportConfig.executionWeekDays.find((elm) => elm === weekday)
            })),
            reports: reports.map(report => {

                const reportItem = reportConfig.reportItems ? reportConfig.reportItems.filter((elm) => elm.name === report) : [];
                return {
                    name: report,
                    enabled: reportItem.length > 0,
                    reportType: {
                        PDF: !!reportItem.find(item => item.type === reportTypes.PDF),
                        EXCEL: !!reportItem.find(item => item.type === reportTypes.EXCEL),
                        CSV: !!reportItem.find(item => item.type === reportTypes.CSV),
                    }
                }
            }),
            contentRelativeType: reportConfig.contentRelativeType ? reportConfig.contentRelativeType : relativeTypes.DAY
        }
    }

    return {
        formValues: formSelector(state, 'content', 'executionType', 'reports'),
        reportConfig,
        loaded,
        loading,
        error,
        saving,
        saved,
        initialValues
    }
};

const getReportConfig = (data, {ErrorFieldRequired, ErrorSelectAtLeastOneDay, ErrorFormat, ErrorEnableAtLeastOneReport, ErrorEnableAtLeastOneReportItem}) => {
    if (!!data.enabled) {
        const errors = {};

        if (data.reports.filter(report => report.enabled).length === 0) {
            errors.reports = {_error: ErrorEnableAtLeastOneReport};
        }

        data.reports.filter(report => report.enabled).forEach(
            report => {
                if (!report.reportType.PDF && !report.reportType.EXCEL && !report.reportType.CSV) {
                    errors.reports = {_error: ErrorEnableAtLeastOneReportItem};
                }
            }
        )

        if (data.executionType === executionTypes.DAY_IN_MONTH) {
            if (!data.executionDay) {
                errors.executionDay = ErrorFieldRequired;
            }
        } else {
            if (data.weekday.filter(day => day.checked).length === 0) {
                errors.weekday = {_error: ErrorSelectAtLeastOneDay};
            }
        }

        if (!data.executionTime) {
            errors.executionTime = ErrorFieldRequired;
        } else if (!/^([0-9]{2}:[0-9]{2})$/.test(data.executionTime)) {
            errors.executionTime = ErrorFormat;
        }

        if (data.content === contentType.RELATIVE) {

            if (!data.contentRelativeNumber) {
                errors.contentRelativeNumber = ErrorFieldRequired;
            }

            if (!data.contentRelativeType) {
                errors.contentRelativeType = ErrorFieldRequired;
            }
        }

        if (Object.keys(errors).length > 0) {
            throw new SubmissionError(errors);
        }
    }

    const reportItems = [];
    data.reports.filter(report => report.enabled).forEach(
        report => {
            if (report.reportType.PDF) {
                reportItems.push({name: report.name, type: reportTypes.PDF })
            }
            if (report.reportType.EXCEL) {
                reportItems.push({name: report.name, type: reportTypes.EXCEL })
            }
            if (report.reportType.CSV) {
                reportItems.push({name: report.name, type: reportTypes.CSV })
            }
        })

    const reportConfig = {
        "userId": data.userId,
        "enabled": !!data.enabled,
        "reportItems": reportItems,
        "executionTime": data.executionTime
    };


    if (data.content === contentType.ALL) {
        reportConfig.contentSinceLastExecution = true;
    } else {
        reportConfig.contentSinceLastExecution = false;
        reportConfig.contentRelativeNumber = data.contentRelativeNumber;
        reportConfig.contentRelativeType = data.contentRelativeType
    }

    if (data.executionType === executionTypes.DAY_IN_MONTH) {
        reportConfig.executionDay = data.executionDay;
    } else {
        reportConfig.executionWeekDays = data.weekday.filter(weekday => weekday.checked).map(weekday => weekday.name);
    }

    return reportConfig;
};


const mapDispatchToProps = (dispatch, ownProps) => {

    return {
        fetchReportConfig: () => dispatch(fetchReportConfig()),
        onSubmit: (data) => {
            const reportConfig = getReportConfig(data, ownProps.strings);
            dispatch(clearSubmitErrors('reportForm'))
            dispatch(updateReportConfig(reportConfig));
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchReportConfig();
    }
};

export default compose(
    translate('ReportForm'),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
    reduxForm({form: 'reportForm'})
)(ReportForm);






// WEBPACK FOOTER //
// ./src/containers/ReportContainer.js